const TENANT_TO_LANG = {
  "gastearsivi": "tr",
  "historyworm": "en"
}

export default TENANT_TO_LANG
